import React from 'react'

import MainMenu from '../MainMenu/MainMenu'

import './index.scss'

const Footer = () => (
  <div className="footer">
    <MainMenu />
  </div>
)

export default Footer
